import { IncludedType } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IUsersource, Usersource } from 'utility-ts-datasource';
import { IAppointmentType, IStudentService, IStudentServiceCategory } from '../types/appointment_interfaces';

export interface IAppointmentReasonUsersourceModel {
  selectedCategory: IStudentServiceCategory;
  selectedService: IStudentService;
  selectedType: IAppointmentType;
}

export type TAppointmentReasonUsersource = IUsersource<IAppointmentReasonUsersourceModel>;

export const AppointmentReasonUsersourceFactory: () => TAppointmentReasonUsersource =
  (): TAppointmentReasonUsersource => {
    return new Usersource<IAppointmentReasonUsersourceModel>({
      selectedCategory: {} as IStudentServiceCategory,
      selectedService: {} as IStudentService,
      selectedType: {} as IAppointmentType
    });
  };



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/usersources/appointment_reason_usersource.ts